"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var ReactDOM = require("react-dom");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var ValidElementChildren = require("../util/valid-element-children");
var create_chained_function_1 = require("../util/create-chained-function");
var ButtonGroup = /** @class */ (function (_super) {
    __extends(ButtonGroup, _super);
    function ButtonGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeKey: typeof _this.props.activeKey === 'undefined'
                ? _this.props.defaultActiveKey
                : _this.props.activeKey
        };
        _this.handleItemKeyDown = function (event, index) {
            if (event.defaultPrevented) {
                return;
            }
            var buttons = ValidElementChildren.toArray(_this.props.children);
            var goToIndex = -1;
            if (event.key === 'ArrowRight') {
                for (var i = index + 1; i < buttons.length; i++) {
                    if (!buttons[i].props.disabled) {
                        goToIndex = i;
                        break;
                    }
                }
            }
            else if (event.key === 'ArrowLeft') {
                for (var i = index - 1; i >= 0; i--) {
                    if (!buttons[i].props.disabled) {
                        goToIndex = i;
                        break;
                    }
                }
            }
            if (goToIndex >= 0) {
                event.preventDefault();
                var clickEvent = document.createEvent('HTMLEvents');
                clickEvent.initEvent('click', true, true);
                var goToButton = ReactDOM.findDOMNode(_this._buttonContainer).childNodes[goToIndex];
                goToButton.focus();
                goToButton.dispatchEvent(clickEvent);
            }
        };
        _this.handleItemClick = function (event, key) {
            event.target.focus();
            if (typeof _this.props.activeKey === 'undefined') {
                // uncontrolled
                _this.setState({
                    activeKey: key
                }, function () {
                    if (typeof _this.props.onChange === 'function') {
                        _this.props.onChange(key);
                    }
                });
            }
            else {
                // controlled
                if (typeof _this.props.onChange === 'function') {
                    _this.props.onChange(key);
                }
            }
        };
        _this.renderButton = function (child, index) {
            var activeKey = _this.props.activeKey != null ? _this.props.activeKey : _this.state.activeKey;
            var key = child.key != null ? child.key : index;
            var disabled = child.props.disabled || _this.props.disabled;
            var props = {
                key: key,
                disabled: disabled,
                ref: child['ref'],
                role: 'tab',
                'aria-selected': activeKey == key,
                'aria-disabled': disabled,
                onClick: create_chained_function_1.default(child.props.onClick, function (event) { return _this.handleItemClick(event, key); }),
                onKeyDown: create_chained_function_1.default(child.props.onKeyDown, function (event) { return _this.handleItemKeyDown(event, index); }),
            };
            return React.cloneElement(child, props);
        };
        return _this;
    }
    ButtonGroup.prototype.componentWillReceiveProps = function (nextProps) {
        if (typeof nextProps.activeKey !== 'undefined' && nextProps.activeKey !== this.state.activeKey) {
            this.setState({
                activeKey: nextProps.activeKey
            });
        }
    };
    ButtonGroup.prototype.render = function () {
        var _this = this;
        var customProps = _1.omit(this.props, Object.keys(ButtonGroup.propTypes));
        var rootClasses = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('button-group')] = true,
            _a[vdl_prefix_1.vdlPrefix('button-group--disabled')] = this.props.disabled,
            _a);
        return (React.createElement("div", __assign({}, customProps, { className: classnames_1.classNames(rootClasses, this.props.className), role: "tablist" }),
            React.createElement("div", { className: vdl_prefix_1.vdlPrefix('button-group__container'), ref: function (c) { _this._buttonContainer = c; } }, ValidElementChildren.map(this.props.children, this.renderButton))));
        var _a;
    };
    ButtonGroup.propTypes = {
        activeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        defaultActiveKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        disabled: PropTypes.bool,
        className: PropTypes.string,
        children: PropTypes.node,
        onChange: PropTypes.func
    };
    ButtonGroup.defaultProps = {
        disabled: false
    };
    return ButtonGroup;
}(React.Component));
exports.ButtonGroup = ButtonGroup;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/button-group/button-group.js
// module id = 500
// module chunks = 0 1 2 3 4 5 6